import * as React from 'react';
import { renderToStaticMarkup } from 'react-dom/server';
import {
  Body,
  Container,
  Head,
  Html,
  Img,
  Preview,
  Section,
  Text,
} from '@react-email/components';

export interface TempTagRequestEmailProps {
  vins: string[];
  senderName: string;
}

export const tempTagRequestEmail = async (
  params: TempTagRequestEmailProps,
): Promise<{ html: string }> => {
  const { vins, senderName } = params;
  const signature = senderName.trim() || 'Optic Truck Works';

  const emailComponent = (
    <Html>
      <Head />
      <Preview>Temp tag request from Optic Truck Works</Preview>
      <Body
        style={{
          fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
          backgroundColor: '#f5f5f5',
          margin: '0',
          padding: '0',
        }}
      >
        <Container
          style={{
            maxWidth: '600px',
            margin: '0 auto',
            backgroundColor: '#ffffff',
            borderRadius: '8px',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
            marginTop: '40px',
            marginBottom: '40px',
          }}
        >
          <Section
            style={{
              padding: '32px',
              textAlign: 'center' as const,
              borderBottom: '1px solid #e0e0e0',
            }}
          >
            <Img
              src="https://firebasestorage.googleapis.com/v0/b/otw-production-91ffb.appspot.com/o/public%2FLogoVariation-OpticTruckWorks-05.png?alt=media&token=c3428c05-276c-4d32-ac33-a7d9d51fe380"
              alt="Optic Truck Works Logo"
              style={{ maxWidth: '200px', height: 'auto', margin: '0 auto' }}
            />
          </Section>

          <Section style={{ padding: '32px' }}>
            <Text
              style={{
                fontSize: '16px',
                color: '#333333',
                lineHeight: '1.6',
                marginBottom: '16px',
              }}
            >
              Hello,
            </Text>

            <Text
              style={{
                fontSize: '16px',
                color: '#333333',
                lineHeight: '1.6',
                marginBottom: '16px',
              }}
            >
              Please send temp tags for the following VIN:
            </Text>

            {vins.map((vin) => (
              <Text
                key={vin}
                style={{
                  fontSize: '16px',
                  color: '#333333',
                  lineHeight: '1.6',
                  marginBottom: '4px',
                  marginTop: '0',
                }}
              >
                {vin}
              </Text>
            ))}

            <Text
              style={{
                fontSize: '16px',
                color: '#333333',
                lineHeight: '1.6',
                marginTop: '24px',
                marginBottom: '16px',
              }}
            >
              Thank you!
            </Text>

            <Text
              style={{
                fontSize: '16px',
                color: '#666666',
                lineHeight: '1.6',
                borderTop: '1px solid #e0e0e0',
                paddingTop: '24px',
                marginTop: '32px',
              }}
            >
              {signature}
            </Text>
          </Section>
        </Container>
      </Body>
    </Html>
  );

  const html = `<!DOCTYPE html>${renderToStaticMarkup(emailComponent)}`;
  return { html };
};
